module.exports = __webpack_public_path__ + "static/media/oh_pack1_sample008_0001.80b86065.png";